import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";
import { getToolTip } from "../../../../utils/getToolTip";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const NetUnitMtdStats = () => {
  const statistics = useSelector((state) => state.membershipSales.statistics);
  const {
    units: { netUnitsMTD, netUnitsMTDLink, netUnitsMTDChange }
  } = statistics;
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <SectionContainer
      title="Net Units MTD"
      toolTip={getToolTip(statistics)}
      toolTipId="membershipNewUnitsToolTipMTD"
    >
      <NumberDisplay
        value={netUnitsMTD}
        url={netUnitsMTDLink}
        disableAnimation={isUserQa}
        toolTipContent={getToolTip(statistics)}
        toolTipId="membershipNewUnitsMTDToolTip"
      />
      <PercentChanged changeValue={netUnitsMTDChange} toolTip="Percentage change" showBorder />
    </SectionContainer>
  );
};

export default NetUnitMtdStats;
